import Vue from 'vue'
import Router from 'vue-router'
import PublicLoginPage from '@/components/pages/Login/LoginPage'
import PublicForgotPasswordPage from '@/components/pages/Login/ForgotPasswordPage'
import PublicResetPasswordPage from '@/components/pages/Login/ResetPasswordPage'
import UnsubscribeFromWorkOrderUpdatesPage from '@/components/pages/UnsubscribeFromWorkOrderUpdatesPage'

import DashboardPage from '@/components/pages/Admin/Dashboard/DashboardPage'

import CustomersPage from '@/components/pages/Admin/Customer/CustomersPage'
import ResellerCustomersPage from '@/components/pages/Admin/Customer/ResellerCustomersPage'
import ResellersPage from '@/components/pages/Admin/Reseller/ResellersPage'
import LicensesPage from '@/components/pages/Admin/License/LicensesPage'
import CustomerLicensesPage from '@/components/pages/Admin/License/CustomerLicensesPage'
import SettingsPreferencesPage from '@/components/pages/Admin/Settings/PreferencesPage'
import SettingsDevPage from '@/components/pages/Admin/Settings/DevPage'
import SystemSettingsPage from '@/components/pages/Admin/Settings/SystemSettingsPage'

import SuperAdminUsersPage from '@/components/pages/Admin/SuperAdmin/UsersPage'

Vue.use(Router)

export const router = new Router({
  mode: 'history',
  linkActiveClass: 'is-active',
  routes: [
    // Login page
    {
      path: '/',
      name: 'Public_Login',
      component: PublicLoginPage,
      meta: {
        layout: 'login',
        title: 'Logga in',
        public: true
      }
    },

    // Forgot password
    {
      path: '/forgot-password',
      name: 'Public_ForgotPassword',
      component: PublicForgotPasswordPage,
      meta: {
        layout: 'login',
        title: 'Glömt lösenord',
        public: true
      }
    },

    // Reset password
    {
      path: '/reset-password/:token',
      name: 'Public_ResetPassword',
      component: PublicResetPasswordPage,
      meta: {
        layout: 'login',
        title: 'Välj nytt lösenord',
        public: true
      }
    },

    // Unsubscribe from work order updates
    {
      path: '/unsubscribe-from-work-order-updates/:code',
      name: 'Public_UnsubscribeFromWorkOrderUpdates',
      component: UnsubscribeFromWorkOrderUpdatesPage,
      meta: {
        layout: 'login',
        title: 'Avregistrera'
      }
    },

    // Dashboard
    {
      path: '/dashboard',
      name: 'Dashboard',
      component: DashboardPage,
      meta: {
        layout: 'admin',
        title: 'Hem » Översikt',
        roles: null,
        permissions: null
      }
    },

    // Customers
    {
      path: '/customers',
      name: 'Customers',
      component: CustomersPage,
      meta: {
        layout: 'admin',
        title: 'Kunder',
        roles: ['Staff'],
        permissions: null
      }
    },
    {
      path: '/reseller-customers/:resellerId',
      name: 'ResellerCustomers',
      component: ResellerCustomersPage,
      props: (route) => {
        const resellerId = Number.parseInt(route.params.resellerId, 10)
        if (Number.isNaN(resellerId)) {
          return 0
        }
        return { resellerId }
      },
      meta: {
        layout: 'admin',
        title: 'Kunder',
        roles: ['Staff'],
        permissions: null
      }
    },

    // Resellers
    {
      path: '/resellers',
      name: 'Resellers',
      component: ResellersPage,
      meta: {
        layout: 'admin',
        title: 'Återförsäljare',
        roles: ['Staff'],
        permissions: null
      }
    },

    // Licenses
    {
      path: '/customer-licenses/:customerId',
      name: 'CustomerLicenses',
      component: CustomerLicensesPage,
      props: (route) => {
        const customerId = Number.parseInt(route.params.customerId, 10)
        if (Number.isNaN(customerId)) {
          return 0
        }
        return { customerId }
      },
      meta: {
        layout: 'admin',
        title: 'Licenser',
        roles: ['Staff'],
        permissions: null
      }
    },

    {
      path: '/licenses',
      name: 'Licenses',
      component: LicensesPage,
      meta: {
        layout: 'admin',
        title: 'Licenser',
        roles: ['Staff'],
        permissions: null
      }
    },

    // Settings » Preferences
    {
      path: '/settings/preferences',
      name: 'Settings_Preferences',
      component: SettingsPreferencesPage,
      meta: {
        layout: 'admin',
        title: 'Gränssnitt',
        roles: null,
        permissions: null
      }
    },

    // Settings » Dev
    {
      path: '/settings/dev',
      name: 'Settings_Dev',
      component: SettingsDevPage,
      meta: {
        layout: 'admin',
        title: 'Dev\'s lounge',
        roles: ['Staff'],
        permissions: ['DeveloperTools']
      }
    },

    // Settings » System settings
    {
      path: '/settings/system-settings',
      name: 'Settings_SystemSettings',
      component: SystemSettingsPage,
      meta: {
        layout: 'admin',
        title: 'Systeminställningar',
        roles: ['Staff'],
        permissions: ['SystemSettings']
      }
    },

    // SuperAdmin » Users
    {
      path: '/superadmin/users',
      name: 'SuperAdmin_Users',
      component: SuperAdminUsersPage,
      meta: {
        layout: 'admin',
        title: 'Användare',
        headingIcon: 'fa-users',
        roles: ['Staff'],
        permissions: ['EditUsers']
      }
    },

    // otherwise redirect to home
    { path: '*', redirect: '/404' }
  ]
})

router.beforeEach((to, from, next) => {
  const user = JSON.parse(localStorage.getItem('user'))
  const authRequired = !to.meta.public

  // Authentication is required but no user isn't logged in, let's redirect to login
  if (authRequired && !user) {
    Vue.prototype.$alert('Din session är avslutad, vänligen logga in igen...')
    return next('/')
  }

  // Authentication is required and user is logged in, let's authorize
  if (authRequired) {
    // Role
    if (to.meta.roles) {
      if (to.meta.roles.some(x => x === user.role) === false) {
        Vue.prototype.$alert('Du är i fel sektion, sorry...')
        return next(false)
      }
    }

    // Permissions
    if (to.meta.permissions) {
      if (to.meta.permissions.some(x => user.permissions.includes(x)) === false) {
        Vue.prototype.$alert('Du har inte tillräcklig behörighet, sorry...')
        return next(false)
      }
    }
  }

  next()
})



// WEBPACK FOOTER //
// ./src/router/index.js